<style scoped>
.v-toolbar__content{
    height: 94px;
}
</style>
<template>
    <div>
        <v-app-bar
            app
            color="white darken-4"
            dense
            shrink-on-scroll
            :src="(currentRouteName == 'Noticia')? '../../image/cabecera.png':'image/cabecera.png'"
            fade-img-on-scroll
            elevation="4"
            extension-height="35px"
            >
            
            <template v-slot:img="{ props }">
                <v-img
                v-bind="props"
                gradient="to top right, rgba(255,255,255,1.0), rgba(100,100,100,.0)"
                >
                </v-img>
            </template>
            <template v-slot:default>
                <template v-if="!isMobile">
                    <v-container>
                        <v-row>
                            <v-toolbar-title class="ml-2 mt-3 red--text text--darken-4" align="top">
                                <router-link to="/"><img :src="(currentRouteName == 'Noticia')? '../../image/logo.png':'image/logo.png'" :width="isMobile? 40:scroll>10? 50:70"/></router-link>
                                <div v-if="scroll>10" style="display:block; float:right;" class="ml-4">
                                    <span style='font-family:"Times new Roman"; font-size:18px; color:#787361; font-weight:400; line-height:0.8em'>
                                        PODER JUDICIAL DEL PERÚ
                                    </span> <br>
                                    <small style="line-height:0.8em"> CORTE SUPERIOR DE JUSTICIA DE PUNO</small>
                                </div>
                                <div v-else style="display:block; float:right" class="ml-4"> 
                                    <span style='font-family:"Times new Roman"; font-size:24px; color:#787361; font-weight:400'>
                                        PODER JUDICIAL DEL PERÚ
                                    </span> <br>
                                    <strong style='font-size:20px;'>
                                        CORTE SUPERIOR DE JUSTICIA DE PUNO
                                    </strong>    
                                </div>
                            </v-toolbar-title>
                            
                            <v-spacer></v-spacer>
                            <v-card color="transparent" tile outlined>
                                <v-layout wrap>
                                    <template v-if="scroll>10">
                                        <router-link to="/" class="text-decoration-none">
                                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-2 red--text text--darken-4" >
                                                <v-icon color="gray">mdi-home</v-icon>
                                                <template v-if="!isMobile">
                                                    <small>Inicio</small>
                                                </template>
                                            </v-btn>
                                        </router-link>
                                        <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-2 red--text text--darken-4">
                                            <v-icon>mdi-mail</v-icon>
                                            <template v-if="!isMobile">
                                                <small>Correo</small>
                                            </template>
                                        </v-btn>
                                        <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-2 red--text text--darken-4">
                                            <v-icon>mdi-view-dashboard</v-icon>
                                            <template v-if="!isMobile">
                                                <small>Intranet</small>
                                                    
                                            </template>
                                        </v-btn>
                                        <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-2 red--text text--darken-4" link href="https://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=10229#.X7_8-WhKiM8" target="_blank">
                                            <v-icon>mdi-book-search</v-icon>
                                            <template v-if="!isMobile">
                                                <small>Transparencia</small>
                                            </template>
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-flex xs6>
                                            <router-link to="/" class="text-decoration-none">
                                                <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-4 red--text text--darken-4">
                                                    <v-icon>mdi-home</v-icon>
                                                    <template v-if="!isMobile">
                                                        Inicio
                                                    </template>
                                                </v-btn>
                                            </router-link>
                                        </v-flex>
                                        <v-flex xs6>
                                        <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-4 red--text text--darken-4" href="https://mail.google.com" target="_blank">
                                            <v-icon>mdi-mail</v-icon>
                                            <template v-if="!isMobile">
                                                Correo
                                            </template>
                                        </v-btn>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-4 red--text text--darken-4" href="https://app.csjpuno.pe" target="_blank">
                                                <v-icon>mdi-view-dashboard</v-icon>
                                                <template v-if="!isMobile">
                                                    Intranet
                                                </template>
                                            </v-btn>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-4 red--text text--darken-4"
                                            link href="https://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=10229#.X7_8-WhKiM8" target="_blank">
                                                <v-icon>mdi-book-search</v-icon>
                                                <template v-if="!isMobile">
                                                    Transparencia
                                                </template>
                                            </v-btn>
                                        </v-flex>
                                    </template>
                                </v-layout>
                            </v-card>
                        </v-row>
                    </v-container>
                </template>
                <template v-else>
                    <!--<v-toolbar-s v-if="isMobile" class="red--text text--darken-4 mt-4 " style="align-self:flex-top">-->
                        <v-card :class="scroll>10?'pt-8 pl-10':'pt-6'" min-height="120px" color="transparent" tile outlined>
                            <img :src="(currentRouteName == 'Noticia')? '../../image/logo.png':'image/logo.png'" :width="scroll>10? 40:70"/>
                            <br v-if="scroll<10">
                            <b> CSJ DE PUNO</b>
                        </v-card>
                        <!--</v-toolbar-s>-->
                    <v-spacer></v-spacer>
                    <v-card :max-width="isMobile? 100: 400" color="transparent" tile outlined v-if="scroll<10">
                        <v-layout wrap>
                            <router-link to="/" class="text-decoration-none">
                                <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-0 red--text text--darken-4">
                                    <v-icon>mdi-home</v-icon>
                                    <template v-if="!isMobile"><small>Inicio</small></template>
                                </v-btn>   
                            </router-link>

                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-0 red--text text--darken-4">
                                <v-icon>mdi-mail</v-icon>
                                <template v-if="!isMobile"><small>Correo</small></template>
                            </v-btn>
                            
                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-0 red--text text--darken-4">
                                <v-icon>mdi-view-dashboard</v-icon>
                                <template v-if="!isMobile"><small>Intranet</small></template>
                            </v-btn>

                            <v-btn :text="!isMobile? true: false" :icon="isMobile? true: false" class="pa-0 red--text text--darken-4" link href="https://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=10229#.X7_8-WhKiM8" target="_blank">
                                <v-icon>mdi-book-search</v-icon>
                                <template v-if="!isMobile"><small>Transparencia</small></template>
                            </v-btn>
                        </v-layout>
                    </v-card>
                </template>
            </template>
            <template v-slot:extension class="mt-5" >
                <v-container v-if="!isMobile">
                    <v-row>
                        <v-spacer/>
                        <v-menu open-on-hover bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                text
                                v-bind="attrs"
                                v-on="on"
                                >
                                Institucional
                                <v-icon>
                                    mdi-menu-down
                                </v-icon>
                                </v-btn>
                            </template>
                            <v-list >
                                <router-link to="/presidencia" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                    <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                        <v-list-item-title>Presidencia</v-list-item-title>
                                    </v-list-item>
                                </router-link>
                                <router-link to="/mision-vision" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                    <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                        <v-list-item-title>Misión y Visión</v-list-item-title>
                                    </v-list-item>
                                </router-link>
                                <!---<router-link to="/sala-plena" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                    <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                        <v-list-item-title>Sala Plena</v-list-item-title>
                                    </v-list-item>
                                </router-link>

                                -->
                                <router-link to="/nosotros" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                    <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                        <v-list-item-title>Nosotros</v-list-item-title>
                                    </v-list-item>
                                </router-link>
                            
                            </v-list>
                        </v-menu>
                        <v-btn text>
                            <v-menu open-on-hover bottom offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    text
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    Sedes Judiciales
                                    <v-icon>
                                        mdi-menu-down
                                    </v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                        <router-link to="/subsedes-zonasur" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                                <v-list-item-title>Zona Sur</v-list-item-title>
                                            </v-list-item>
                                        </router-link>
                                        <router-link to="/subsedes-zonanorte" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                                <v-list-item-title>Zona Norte</v-list-item-title>
                                            </v-list-item>
                                        </router-link>
                                </v-list>
                            </v-menu>
                        </v-btn>
                        <!--<v-btn class="text-decoration-none" text href="#" target="_blank">
                            Publicaciones
                        </v-btn>
                    -->
                        <!--<router-link to="/noticias" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-btn text link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-icon>mdi-search</v-icon>
                                Noticias
                            </v-btn>
                        </router-link>
                        -->
                        
                    </v-row>
                </v-container>
                <template v-else>
                    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                </template>
            </template>

        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            temporary
            >
            <v-card class="pa-2" align="center">
                <img src="image/logo.png" width="80px"/>
                
                <h4 class="mt-4">CORTE SUPERIOR DE JUSTICIA DE PUNO</h4>
            </v-card>
            <v-list
                nav
                dense
            >
                <v-list-item-group
                v-model="group"
                active-class="red--text text--accent-4"
                >
                    <v-subheader class="red--text text--darken-4">MENU</v-subheader>

                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-title>INSTITUCIONAL </v-list-item-title>
                        </template>
                        <router-link to="/presidencia" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-list-item-title>Presidencia</v-list-item-title>
                            </v-list-item>
                        </router-link>
                        <router-link to="/mision-vision" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-list-item-title>Misión y Visión</v-list-item-title>
                            </v-list-item>
                        </router-link>
                        <router-link to="/nosotros" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-list-item-title>Nosotros</v-list-item-title>
                            </v-list-item>
                        </router-link>
                    </v-list-group>
                    <v-list-group
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-title>Sedes Judiciales </v-list-item-title>
                        </template>
                        <router-link to="/subsedes-zonasur" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-list-item-title>Zona Sur</v-list-item-title>
                            </v-list-item>
                        </router-link>
                        <router-link to="/subsedes-zonanorte" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                            <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                                <v-list-item-title>Zona Norte</v-list-item-title>
                            </v-list-item>
                        </router-link>
                    </v-list-group>

                    <v-list-item class="text-decoration-none" link href="#" target="_blank">
                        <v-list-item-title >Pubilcaciones</v-list-item-title>
                    </v-list-item>
                    <!--<router-link to="/noticias" class="text-decoration-none" v-slot="{ href, navigate, isActive }">
                        <v-list-item link :class="isActive? 'v-item--active v-list-item--active':''" :href="href" @click="navigate" >
                            <v-list-item-title>NOTICIAS</v-list-item-title>
                        </v-list-item>
                    </router-link>
                    -->
                </v-list-item-group>               
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
export default {
    data: () => ({ 
        isMobile: false,
        scroll:0,
        drawer: false,
        group: null,
    }),
    beforeDestroy () {
        if (typeof window === 'undefined') return

        window.removeEventListener('resize', this.onResize, { passive: true })
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },
    mounted () {
        this.onResize()
        window.addEventListener('scroll', this.onScroll, { passive: true })
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    methods: {
        onResize () {
            this.isMobile = window.innerWidth < 600
        },
        onScroll () {
            this.scroll = window.scrollY
            //console.log(window.scrollY);
        },
    },
}
</script>